import { useState } from 'react';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import NotificationCenter from './components/NotificationCenter';
import PreferencesPanel from './components/PreferencesPanel';
import PermissionsPanel from './components/PermissionsPanel';

type Tab = 'center' | 'preferences' | 'permissions';

const tabs: { key: Tab; label: string; icon: string }[] = [
  { key: 'center', label: 'Centro', icon: 'ri-notification-3-line' },
  { key: 'preferences', label: 'Preferencias', icon: 'ri-equalizer-line' },
  { key: 'permissions', label: 'Permisos Push', icon: 'ri-smartphone-line' },
];

export default function NotificationsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('center');

  return (
    <div className="min-h-screen bg-background-100/50 flex flex-col">
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <div className="max-w-4xl mx-auto px-4 md:px-6 pb-10">
          {/* Page Header */}
          <div className="mb-6 md:mb-8">
            <div className="flex items-center gap-3 mb-1">
              <div className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-notification-3-line text-background-50 text-lg"></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Notificaciones</h1>
                <p className="text-xs text-foreground-500">Centro de avisos y alertas de RadioFrecuenciaWeb</p>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex items-center gap-1 mb-6 bg-background-50 rounded-2xl p-1.5">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-all cursor-pointer flex-1 justify-center ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-500 hover:text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="min-h-[400px]">
            {activeTab === 'center' && <NotificationCenter />}
            {activeTab === 'preferences' && <PreferencesPanel />}
            {activeTab === 'permissions' && <PermissionsPanel />}
          </div>
        </div>
      </main>

      <Footer />

      <div className="md:hidden h-20"></div>
    </div>
  );
}